export const FETCH_TRIPS_LIST = "FETCH_TRIPS_LIST";
export const SET_ALL_TRIPS_LIST = "ALL_TRIPS_LIST";
export const FETCH_TRIP_DETAILS = "FETCH_TRIP_DETAILS";
export const SET_TRIP_DETAILS = "SET_TRIP_DETAILS";
export const RESET_TRIP_DETAILS = "RESET_TRIP_DETAILS";
